import * as z from "zod/v4";

export const getRecoverConfigBySmsTemplateId = {
  name: "getRecoverConfigBySmsTemplateId" as const,
  input: z.object({ smsTemplateId: z.string() }),
  output: z.object({ recoverConfigId: z.string().nullable() }),
};
